import Vue from 'vue'

/*
  Instance 관리 (2018/06/15 정재윤)
    - Global 데이터 등록 관리
*/

// fdp 용 인스턴스 관리
Vue.prototype.$fdp = {
  $vue: undefined,
  $router: undefined,
  $http: undefined,
  $socket: undefined,
  $store: undefined,
  $lang: undefined,
  $log: undefined
}

// 전역 관리
window.vue = {}

// datepicker  로딩순서 관련
import('vue2-datepicker')
import('vue2-datepicker/index.css')

// import('@/assets/js/StyleModule.js').then(module => {
//   console.log('MMP CSS 모듈 로드 완료', module)
// }).catch(error => {
//   console.log('MMP CSS 모듈 로드 실패', error)
// })
let styleModule
if (window.location.hostname.includes('bootcamp.')) {
  console.log('KDT 경로 감지 - KdtStyleModule.js 로드')
  styleModule = import('@/assets/js/KdtStyleModule.js')
} else {
  console.log('일반 경로 - StyleModule.js 로드')
  styleModule = import('@/assets/js/StyleModule.js')
}

styleModule.then(module => {
  console.log('스타일 모듈 로드 완료', module)
}).catch(error => {
  console.log('스타일 모듈 로드 실패', error)
})

// config 로딩
console.log('# process.env.NODE_ENV: ' + process.env.NODE_ENV)
if (process.env.NODE_ENV === 'local') {
  window.vue.config = require('@/config/env/local.json')
  console.log('load ' + 'local.json')
} else if (process.env.NODE_ENV === 'development') {
  window.vue.config = require('@/config/env/dev.json')
  console.log('load ' + 'dev.json')
} else if (process.env.NODE_ENV === 'stage') {
  window.vue.config = require('@/config/env/stg.json')
  console.log('load ' + 'stg.json')
} else {
  window.vue.config = require('@/config/env/prd.json')
  console.log('load ' + 'prd.json')
}

// 전역 함수
window.vue.getInstance = function (arg) {
  if (arg === 'vue') {
    return Vue.prototype.$fdp.$vue
  } else if (arg === 'router') {
    return Vue.prototype.$fdp.$router
  } else if (arg === 'http') {
    return Vue.prototype.$fdp.$http
  } else if (arg === 'socket') {
    return Vue.prototype.$fdp.$socket
  } else if (arg === 'store') {
    return Vue.prototype.$fdp.$store
  } else if (arg === 'lang') {
    return Vue.prototype.$fdp.$lang
  } else if (arg === 'log') {
    return Vue.prototype.$fdp.$log
  } else {
    return undefined
  }
}

window.vue.setInstance = function (arg, instance) {
  if (arg === 'vue') {
    Vue.prototype.$fdp.$vue = instance
  } else if (arg === 'router') {
    Vue.prototype.$fdp.$router = instance
  } else if (arg === 'http') {
    Vue.prototype.$fdp.$http = instance
  } else if (arg === 'socket') {
    Vue.prototype.$fdp.$socket = instance
  } else if (arg === 'store') {
    Vue.prototype.$fdp.$store = instance
  } else if (arg === 'lang') {
    Vue.prototype.$fdp.$lang = instance
  } else if (arg === 'log') {
    Vue.prototype.$fdp.$log = instance
  } else {
  }
}

// Vuex
window.vue.getStoreMap = function () {
  return Vue.prototype.$fdp.$storeMap
}

window.vue.setStoreMap = function (map) {
  Vue.prototype.$fdp.$storeMap = map
}

window.vue.getStore = function (arg) {
  if (arg === 'root') {
    // root vuex
    return Vue.prototype.$fdp.$store
  } else {
    // system, user vuex
    if (Vue.prototype.$fdp.$storeMap.get(arg) === undefined) {
      return undefined
    } else {
      return Vue.prototype.$fdp.$storeMap.get(arg).$store
    }
  }
}

// http
window.vue.loadRes = function (...args) {
  return Vue.prototype.$fdp.$http.loadRes(...args)
}

window.vue.get = function (...args) {
  return Vue.prototype.$fdp.$http.get(...args)
}

window.vue.post = function (...args) {
  return Vue.prototype.$fdp.$http.post(...args)
}

window.vue.upload = function (...args) {
  return Vue.prototype.$fdp.$http.upload(...args)
}

window.vue.put = function (...args) {
  return Vue.prototype.$fdp.$http.put(...args)
}

window.vue.delete = function (...args) {
  return Vue.prototype.$fdp.$http.delete(...args)
}
// log
window.vue.debug = function (fileName, msg) {
  Vue.prototype.$fdp.$log.debug(fileName, msg)
}

window.vue.warn = function (fileName, msg) {
  Vue.prototype.$fdp.$log.warn(fileName, msg)
}

window.vue.info = function (fileName, msg) {
  Vue.prototype.$fdp.$log.info(fileName, msg)
}

window.vue.error = function (fileName, msg) {
  Vue.prototype.$fdp.$log.error(fileName, msg)
}

// i18n
window.vue.setLocaleResource = function (locale) {
  return Vue.prototype.$fdp.$lang.setLocaleResource(locale)
}

window.vue.setLocale = function (locale) {
  Vue.prototype.$fdp.$lang.setLocale(locale)
}

window.vue.getI18n = function () {
  return Vue.prototype.$fdp.$lang.i18n
}

Vue.mixin(
  {
    methods: {
      loadRes: window.vue.loadRes,
      get: window.vue.get,
      post: window.vue.post,
      upload: window.vue.upload,
      put: window.vue.put,
      delete: window.vue.delete,
      setLocale: window.vue.setLocale,
      setLocaleResource: window.vue.setLocaleResource,
      getStore: window.vue.getStore
    }
  }
)



// WEBPACK FOOTER //
// ./src/_fdp/core/global/index.js